import { CloudCustomerAddress } from "@omni/types/api/customer/cloud/address.model";
import { AddressType } from "@omni/types/api/customer/cloud/shared/enums/addressType.enum";
import { cn } from "@omni/utils/styles";

import { AddressBlock } from "@/components/Account/Profile/ProfileAddressBook/components/AddressBlock/addressBlock.component";
import { Divider } from "@/components/General/Divider/divider.component";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    defaultPaymentAddress?: CloudCustomerAddress;
    defaultDeliveryAddress?: CloudCustomerAddress;
    canDelete: boolean;
    updateDefaultBilling: (address: CloudCustomerAddress) => Promise<void>;
    updateDefaultDelivery: (address: CloudCustomerAddress) => Promise<void>;
};

const DefaultAddresses = ({
    defaultPaymentAddress,
    defaultDeliveryAddress,
    canDelete,
    updateDefaultBilling,
    updateDefaultDelivery
}: Props) => {
    const { t } = useGranite();
    return (
        <>
            {(defaultPaymentAddress || defaultDeliveryAddress) && (
                <>
                    {(defaultPaymentAddress?.defaultDeliveryAddress ||
                        defaultDeliveryAddress?.defaultPaymentAddress) && (
                        <Row>
                            <Col>
                                <h3 className={cn("mt-1")}>
                                    {t("address.title.paymentAndDelivery")}
                                </h3>
                                <Divider className={cn("mb-3 mt-0")} />
                            </Col>
                        </Row>
                    )}
                    <Row>
                        {defaultPaymentAddress && (
                            <Col
                                xs={12}
                                md={6}
                            >
                                {!defaultPaymentAddress.defaultDeliveryAddress && (
                                    <>
                                        <h3 className={cn("mt-1")}>
                                            {t("address.title.payment")}
                                        </h3>
                                        <Divider className={cn("mb-3")} />
                                    </>
                                )}
                                <AddressBlock
                                    address={defaultPaymentAddress}
                                    updateDefaultDelivery={
                                        updateDefaultDelivery
                                    }
                                    updateDefaultBilling={updateDefaultBilling}
                                    canDelete={canDelete}
                                    addressType={AddressType.Payment}
                                />
                            </Col>
                        )}
                        <Col
                            xs={12}
                            md={6}
                        >
                            {defaultDeliveryAddress &&
                                !defaultDeliveryAddress.defaultPaymentAddress && (
                                    <>
                                        <h3 className={cn("mt-1")}>
                                            {t("address.title.delivery")}
                                        </h3>
                                        <Divider className={cn("mb-3")} />
                                        <AddressBlock
                                            address={defaultDeliveryAddress}
                                            updateDefaultDelivery={
                                                updateDefaultDelivery
                                            }
                                            updateDefaultBilling={
                                                updateDefaultBilling
                                            }
                                            canDelete={canDelete}
                                            addressType={AddressType.Delivery}
                                        />
                                    </>
                                )}
                        </Col>
                    </Row>
                </>
            )}
        </>
    );
};

export default DefaultAddresses;
